/* eslint-disable no-nested-ternary */
import React, { useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import { useTheme } from '@material-ui/core/styles';
import { formatMMtoHHMMArr } from '@mummssoftware/utils/formatters';
import {
  handleTimeChange,
  isTimerEmpty,
} from '@mummssoftware/utils/visitUtils';
import { hasTimerDuration } from '@mummssoftware/utils/utils';
import {
  SET_TIME,
  SET_EDIT_TIME,
  VisitsGlobalContext,
} from '@mummssoftware/global-context';
import { TimerDiv, EditTimeDiv, TimerText } from './styledDiv';
import { useStyles } from './style';
import defaults from '../../../../translations/en.json';

type EditableTimerProps = {
  durationmins: null | number;
};

// todo use in common-ui
export const EditableTimer = ({ durationmins }: EditableTimerProps) => {
  const { palette } = useTheme() as any;

  const classes = useStyles();
  const timerId = 'hour-edit';
  const { dispatchVG, timerDuration } = useContext(VisitsGlobalContext);

  const visitTime = durationmins
    ? formatMMtoHHMMArr(durationmins)
    : ['00', '00'];

  const [hour, minute] = hasTimerDuration(timerDuration)
    ? timerDuration
    : visitTime;

  const onHourChange = (event: any) => {
    const targetValue = event.target.value;
    dispatchVG({
      type: SET_EDIT_TIME,
      payload: [targetValue, minute],
    });
    dispatchVG({
      type: SET_TIME,
      payload: [targetValue, minute],
    });
  };

  const onMinChange = (event: any) => {
    const targetValue = event.target.value;
    dispatchVG({
      type: SET_TIME,
      payload: [hour, targetValue],
    });
    dispatchVG({
      type: SET_EDIT_TIME,
      payload: [targetValue, hour],
    });
  };
  const handleHourChange = handleTimeChange(onHourChange);
  const handleMinChange = handleTimeChange(onMinChange);

  const inputProps = {
    classes: {
      input: classes.input,
      root: classes.outlined,
    },
  };
  const timerIsEmpty = isTimerEmpty(hour, minute);

  return (
    <EditTimeDiv className="edit-time-div">
      <FormHelperText
        style={{
          color: (timerIsEmpty && palette.error.light) || undefined,
          paddingBottom: '5px',
        }}
        id="component-helper-text"
      >
        {defaults.editTime}
      </FormHelperText>
      <TimerDiv edit>
        <TextField
          label="HH"
          id={timerId}
          variant="outlined"
          value={hour}
          InputProps={inputProps}
          onChange={handleHourChange}
          // eslint-disable-next-line react/jsx-no-duplicate-props
          inputProps={{ maxLength: 2 }}
          InputLabelProps={{
            shrink: true,
            classes: { root: classes.labelInput },
          }}
        />
        <TimerText>:</TimerText>
        <TextField
          label="MM"
          id="min-edit"
          variant="outlined"
          value={minute}
          InputProps={inputProps}
          onChange={handleMinChange}
          // eslint-disable-next-line react/jsx-no-duplicate-props
          inputProps={{ maxLength: 2 }}
          InputLabelProps={{
            shrink: true,
            classes: { root: classes.labelInput },
          }}
        />
      </TimerDiv>
    </EditTimeDiv>
  );
};

export default EditableTimer;
